import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft } from "lucide-react";
import LegalLayout from "./LegalLayout";
import useSeo from "../hooks/useSeo";

export default function Danke() {
  useSeo({
    title: "Danke! Deine Nachricht ist raus. | IYM – Im Your Man",
    description:
      "Danke für deine Anfrage bei IYM. Wir melden uns innerhalb von 24 Stunden bei dir.",
    path: "/kontakt/danke",
    robots: "noindex, follow",
  });

  return (
    <LegalLayout title="Deine Nachricht ist raus.">
      <div className="-mt-4">
        <div className="mb-8 flex h-20 w-20 items-center justify-center rounded-full bg-[#2c3bff]/10">
          <CheckCircle2 className="h-10 w-10 text-[#2c3bff]" />
        </div>

        <p className="max-w-xl text-lg leading-relaxed text-[#4a453d]">
          Danke für deine Anfrage. Wir haben deine Nachricht erhalten und melden uns
          <strong className="text-ink"> innerhalb von 24 Stunden</strong> bei dir – meistens deutlich schneller.
        </p>

        <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-[#565149]">
          In der Zwischenzeit kannst du dir gerne unsere aktuellen Referenzen ansehen. Wenn es
          dringend ist, schreib uns direkt eine E-Mail an{" "}
          <a href="mailto:info.iym24@gmail.com" className="text-[#2c3bff] hover:underline">
            info.iym24@gmail.com
          </a>
          .
        </p>

        <div className="mt-10 flex flex-wrap gap-3">
          <Link
            to="/"
            data-testid="danke-home"
            className="btn-fill flex items-center gap-2 rounded-full bg-[#2c3bff] px-6 py-3.5 font-display text-sm uppercase tracking-wide text-white"
          >
            <ArrowLeft className="h-4 w-4" />
            Zur Startseite
          </Link>
          <Link
            to="/#arbeiten"
            data-testid="danke-arbeiten"
            className="rounded-full border border-black/15 px-6 py-3.5 font-display text-sm uppercase tracking-wide text-ink transition-colors hover:bg-ink hover:text-white"
          >
            Arbeiten ansehen
          </Link>
        </div>
      </div>
    </LegalLayout>
  );
}
